<div class="page">

  <div class="header">
    <div class="titleClock">
      <h1 class="text-nowrap">GESTIÓN DE BUSES</h1>

      <div class="reloj">{{horaActual}}</div>
    </div>

    <div class="terminal" [tooltip]="sucursalesSelectedNombresLargos">
      <p><strong>TERMINAL:</strong>{{sucursalesSelectedNombres}}</p>
      <button class="btn btnBlack" (click)="openModalCambiarSucursal()">CAMBIAR</button>
    </div>

  </div>

  <div class="boxWhite">
    <div class="headBox">
      <div class="filtros" style="display: flex; flex-wrap: wrap; gap: 10px;">
        <div class="buscar itemForm">
          <input type="search" class="form-control" placeholder="Buscar..." [(ngModel)]="textoBusqueda"
            (ngModelChange)="onFiltroCambio()">
        </div>

        <div class="select itemForm d-lg-block d-none">
          <select class="form-select" [(ngModel)]="tipoBus" (ngModelChange)="onFiltroCambio()">
            <option disabled>Tipo de bus</option>
            <option value="Todos">Todos ({{cantidadTodos}})</option>
            <option value="A">A ({{cantidadTipoMovilA}})</option>
            <option value="B">B ({{cantidadTipoMovilB}})</option>
            <option value="C">C ({{cantidadTipoMovilC}})</option>
            <option value="BP">BP ({{cantidadTipoMovilBP}})</option>
          </select>
        </div>

        <div class="select itemForm d-lg-block d-none ">
          <select class="form-select" [(ngModel)]="unidadSeleccionada" (ngModelChange)="onFiltroCambio()">
            <option disabled>Unidad de Servicio</option>
            <option value="Todos">Todos ({{cantidadTodos}})</option>
            <option value="conecta_17">Conecta_17 ({{cantidadUnidadConecta17}})</option>
            <option value="conecta_18">Conecta_18 ({{cantidadUnidadConecta18}})</option>
          </select>
        </div>

        <div class="select itemForm d-lg-block d-none">
          <select class="form-select" [(ngModel)]="tipoSeleccionado" (ngModelChange)="onFiltroCambio()">
            <option disabled>Energía de Bus</option>
            <option value="Todos">Todos ({{cantidadTodos}})</option>
            <option value="ELECTRICO">Electricos ({{cantidadElectricos}})</option>
            <option value="DIESEL">Diesel ({{cantidadDiesel}})</option>
          </select>
        </div>
        <div class="select itemForm d-lg-block d-none">
          <div class="slider-container">
            <label>Carga mín: {{ cargaElectricaMinima }}%</label>
            <input type="range" class="form-range" min="0" max="100" [(ngModel)]="cargaElectricaMinima"
              (change)="onMinChange(cargaElectricaMinima)" />
          </div>
        </div>
        <div class="select itemForm d-lg-block d-none">
          <div class="slider-container">
            <label>Carga máx: {{ cargaElectricaMaxima }}%</label>
            <input type="range" class="form-range" min="0" max="100" [(ngModel)]="cargaElectricaMaxima"
              (change)="onMaxChange(cargaElectricaMaxima)" />
          </div>
        </div>

      </div>

      <div class="d-flex mt-sm-0 mt-3 align-items-center gap-3">
        <div class="btnSync">
          <div class="ico" (click)="reload()" [tooltip]="'Recargar datos'">
            <img src="assets/img/icoRefresh.svg" alt="">
          </div>
          <ng-select class="selectNg" [items]="recargas" bindLabel="label" bindValue="value" [(ngModel)]="recarga"
            placeholder="RECARGAR CADA..." (change)="calcularTime()" (clear)="recarga = 0; calcularTime()">
          </ng-select>
          <div class="barra" *ngIf="recarga != 0">
            <progressbar [max]="recarga/1000" [value]="contador/1000" [animate]="true" [striped]="true">
            </progressbar>
          </div>
        </div>

        <button class="ms-auto btn btnFilter d-lg-none d-block" (click)="filtroColap = !filtroColap">
          <img src="assets/img/icoFiltro.svg">
        </button>
      </div>

    </div>

    <div class="groupColums">
      <div class="colBox">
        <div class="label">DISPONIBLES ({{movilesPorEstado['DISPONIBLE']?.length || 0}})
          {{porcentajesPorEstado['DISPONIBLE'] || '0%'}}</div>

        <div class="contBox">
          <!--<div *ngFor="let movil of getMovilesDisponibles" [ngClass]="{'fade-out': this.listadoMovilesEstadosModificadosPorMqttFadeOut.includes(movil.uuid),
            'fade-in': this.listadoMovilesEstadosModificadosPorMqtt.includes(movil.uuid)}">-->
          <div *ngFor="let movil of movilesPorEstado['DISPONIBLE']; trackBy: trackByUuid">
            <div class="cardBx" [ngClass]="{
                'enRuta' : movil.tipoMovil.combustible === 'ELECTRICO',
                'enCarga' : movil.tipoMovil.combustible === 'DIESEL'
              }" (click)="cambiarEstadoBus(movil)">
              <!-- <span *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">{{movil.estadoCarga}}</span>
              <span *ngIf="movil.tipoMovil.combustible === 'DIESEL'">{{movil.nivelCombustible}}</span> -->
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">
                <div class="battery-level"
                  [ngClass]="{'poca-bateria': movil.estadoCarga <= 35 && movil.estadoCarga > 11, 'cargar-bateria': movil.estadoCarga <= 10}"
                  [ngStyle]="{'height': movil.estadoCarga + '%'}"></div>
              </div>
              <div style="width: 20; margin: 5px 2px; padding:2px" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
              </div>
              <!--
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
                <div class="battery-level" [ngClass]="{'poca-bateria': movil.nivelCombustible <= 35 && movil.nivelCombustible > 11, 'cargar-bateria': movil.nivelCombustible <= 10}" [ngStyle]="{'height': movil.nivelCombustible + '%'}"></div>
              </div>
              -->
              <p>{{movil.patente}} {{movil.tipoMovil.codigo}}</p>
              <span>{{ movil.tiempoEnEstado }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="colBox">
        <div class="label">ASIGNADOS/CONFIRMADOS ({{ (movilesPorEstado['ASIGNADO']?.length || 0) + (movilesPorEstado['CONFIRMADO']?.length || 0) }})
          {{porcentajesPorEstado['ASIGNADO_CONFIRMADO'] || '0%'}}</div>

        <div class="contBox">
          <div *ngFor="let movil of movilesPorEstado['ASIGNADO']; trackBy: trackByUuid">
            <div class="cardBx" [ngClass]="{
              'enRuta' : movil.tipoMovil.combustible === 'ELECTRICO',
              'enCarga' : movil.tipoMovil.combustible === 'DIESEL'
              }" (click)="cambiarEstadoBus(movil)">
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">
                <div class="battery-level"
                  [ngClass]="{'poca-bateria': movil.estadoCarga <= 35 && movil.estadoCarga > 11, 'cargar-bateria': movil.estadoCarga <= 10}"
                  [ngStyle]="{'height': movil.estadoCarga + '%'}"></div>
              </div>
              <div style="width: 20; margin: 5px 2px; padding:2px" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
              </div>
              <p>{{movil.patente}} {{movil.tipoMovil.codigo}}</p>
              <span [ngClass]="isTiempoCritico(movil.estadoFechaTerminoPlanificado)">
                {{ movil.tiempoEnEstado }}
              </span>
            </div>
          </div>
          <div *ngFor="let movil of movilesPorEstado['CONFIRMADO']; trackBy: trackByUuid">
            <div class="cardBx" [ngClass]="{
              'enRuta' : movil.tipoMovil.combustible === 'ELECTRICO',
              'enCarga' : movil.tipoMovil.combustible === 'DIESEL'
              }" (click)="cambiarEstadoBus(movil)">
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">
                <div class="battery-level"
                  [ngClass]="{'poca-bateria': movil.estadoCarga <= 35 && movil.estadoCarga > 11, 'cargar-bateria': movil.estadoCarga <= 10}"
                  [ngStyle]="{'height': movil.estadoCarga + '%'}"></div>
              </div>
              <div style="width: 20; margin: 5px 2px; padding:2px" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
              </div>
              <p>{{movil.patente}} {{movil.tipoMovil.codigo}}</p>
              <span [ngClass]="isTiempoCritico(movil.estadoFechaTerminoPlanificado)">
                {{ movil.tiempoEnEstado }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="colBox">
        <div class="label">EN RUTA ({{movilesPorEstado['EN_CURSO']?.length || 0}}) {{porcentajesPorEstado['EN_CURSO'] ||
          '0%'}}</div>
        <div class="contBox">
          <!--<div *ngFor="let movil of getMovilesEnCurso" [ngClass]="{'fade-in': this.listadoMovilesEstadosModificadosPorMqtt.includes(movil.uuid)}">-->
          <div *ngFor="let movil of movilesPorEstado['EN_CURSO']; trackBy: trackByUuid">
            <div class="cardBx" [ngClass]="{
              'enRuta' : movil.tipoMovil.combustible === 'ELECTRICO',
              'enCarga' : movil.tipoMovil.combustible === 'DIESEL'
              }" (click)="cambiarEstadoBus(movil)">
              <!-- <span *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">{{movil.estadoCarga}}</span>
              <span *ngIf="movil.tipoMovil.combustible === 'DIESEL'">{{movil.nivelCombustible}}</span> -->
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">
                <div class="battery-level"
                  [ngClass]="{'poca-bateria': movil.estadoCarga <= 35 && movil.estadoCarga > 11, 'cargar-bateria': movil.estadoCarga <= 10}"
                  [ngStyle]="{'height': movil.estadoCarga + '%'}"></div>
              </div>
              <div style="width: 20; margin: 5px 2px; padding:2px" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
              </div>
              <!--
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
                <div class="battery-level" [ngClass]="{'poca-bateria': movil.nivelCombustible <= 35 && movil.nivelCombustible > 11, 'cargar-bateria': movil.nivelCombustible <= 10}" [ngStyle]="{'height': movil.nivelCombustible + '%'}"></div>
              </div>
              -->
              <p>{{movil.patente}} {{movil.tipoMovil.codigo}}</p>
              <span [ngClass]="isTiempoCritico(movil.estadoFechaTerminoPlanificado)">
                {{ movil.tiempoEnEstado }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="colBox">
        <div class="label">EN LAVADO ({{movilesPorEstado['EN_LAVADO']?.length || 0}})
          {{porcentajesPorEstado['EN_LAVADO'] || '0%'}}</div>

        <div class="contBox">
          <!--<div *ngFor="let movil of getMovilesEnLavado" [ngClass]="{'fade-in': this.listadoMovilesEstadosModificadosPorMqtt.includes(movil.uuid)}">-->
          <div *ngFor="let movil of movilesPorEstado['EN_LAVADO']; trackBy: trackByUuid">
            <div class="cardBx" [ngClass]="{
              'enRuta' : movil.tipoMovil.combustible === 'ELECTRICO',
              'enCarga' : movil.tipoMovil.combustible === 'DIESEL'
              }" (click)="cambiarEstadoBus(movil)">
              <!-- <span *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">{{movil.estadoCarga}}</span>
              <span *ngIf="movil.tipoMovil.combustible === 'DIESEL'">{{movil.nivelCombustible}}</span> -->
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">
                <div class="battery-level"
                  [ngClass]="{'poca-bateria': movil.estadoCarga <= 35 && movil.estadoCarga > 11, 'cargar-bateria': movil.estadoCarga <= 10}"
                  [ngStyle]="{'height': movil.estadoCarga + '%'}"></div>
              </div>
              <div style="width: 20; margin: 5px 2px; padding:2px" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
              </div>
              <!--
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
                <div class="battery-level" [ngClass]="{'poca-bateria': movil.nivelCombustible <= 35 && movil.nivelCombustible > 11, 'cargar-bateria': movil.nivelCombustible <= 10}" [ngStyle]="{'height': movil.nivelCombustible + '%'}"></div>
              </div>
              -->
              <p>{{movil.patente}} {{movil.tipoMovil.codigo}}</p>
              <span [ngClass]="isTiempoCritico(movil.estadoFechaTerminoPlanificado)">
                {{ movil.tiempoEnEstado }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="colBox">
        <div class="label">EN CARGA ({{movilesPorEstado['EN_CARGA']?.length || 0}}) {{porcentajesPorEstado['EN_CARGA']
          || '0%'}}</div>

        <div class="contBox">
          <!--<div *ngFor="let movil of getMovilesEnCarga" [ngClass]="{'fade-in': this.listadoMovilesEstadosModificadosPorMqtt.includes(movil.uuid)}">-->
          <div *ngFor="let movil of movilesPorEstado['EN_CARGA']; trackBy: trackByUuid">
            <div class="cardBx" [ngClass]="{
              'enRuta' : movil.tipoMovil.combustible === 'ELECTRICO',
              'enCarga' : movil.tipoMovil.combustible === 'DIESEL'
              }" (click)="cambiarEstadoBus(movil)">
              <!-- <span *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">{{movil.estadoCarga}}</span>
              <span *ngIf="movil.tipoMovil.combustible === 'DIESEL'">{{movil.nivelCombustible}}</span> -->
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">
                <div class="battery-level"
                  [ngClass]="{'poca-bateria': movil.estadoCarga <= 35 && movil.estadoCarga > 11, 'cargar-bateria': movil.estadoCarga <= 10}"
                  [ngStyle]="{'height': movil.estadoCarga + '%'}"></div>
              </div>
              <div style="width: 20; margin: 5px 2px; padding:2px" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
              </div>
              <!--
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
                <div class="battery-level" [ngClass]="{'poca-bateria': movil.nivelCombustible <= 35 && movil.nivelCombustible > 11, 'cargar-bateria': movil.nivelCombustible <= 10}" [ngStyle]="{'height': movil.nivelCombustible + '%'}"></div>
              </div>
              -->
              <p>{{movil.patente}} {{movil.tipoMovil.codigo}}</p>
              <span [ngClass]="isTiempoCritico(movil.estadoFechaTerminoPlanificado)">
                {{ movil.tiempoEnEstado }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="colBox">
        <div class="label">EN TALLER ({{movilesPorEstado['EN_TALLER']?.length || 0}})
          {{porcentajesPorEstado['EN_TALLER'] || '0%'}}</div>

        <div class="contBox">
          <!--<div *ngFor="let movil of getMovilesEnTaller" [ngClass]="{'fade-out': this.listadoMovilesEstadosModificadosPorMqttFadeOut.includes(movil.uuid),
           'fade-in': this.listadoMovilesEstadosModificadosPorMqtt.includes(movil.uuid)}">-->
          <div *ngFor="let movil of movilesPorEstado['EN_TALLER']; trackBy: trackByUuid">
            <div class="cardBx" [ngClass]="{
                'enRuta' : movil.tipoMovil.combustible === 'ELECTRICO',
                'enCarga' : movil.tipoMovil.combustible === 'DIESEL'
                }" (click)="cambiarEstadoBus(movil)">
              <!-- <span *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">{{movil.estadoCarga}}</span>
              <span *ngIf="movil.tipoMovil.combustible === 'DIESEL'">{{movil.nivelCombustible}}</span> -->
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'ELECTRICO'">
                <div class="battery-level"
                  [ngClass]="{'poca-bateria': movil.estadoCarga <= 35 && movil.estadoCarga > 11, 'cargar-bateria': movil.estadoCarga <= 10}"
                  [ngStyle]="{'height': movil.estadoCarga + '%'}"></div>
              </div>
              <div style="width: 20; margin: 5px 2px; padding:2px" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
              </div>
              <!--
              <div class="battery" *ngIf="movil.tipoMovil.combustible === 'DIESEL'">
                <div class="battery-level" [ngClass]="{'poca-bateria': movil.nivelCombustible <= 35 && movil.nivelCombustible > 11, 'cargar-bateria': movil.nivelCombustible <= 10}" [ngStyle]="{'height': movil.nivelCombustible + '%'}"></div>
              </div>
              -->
              <p>{{movil.patente}} {{movil.tipoMovil.codigo}}</p>
              <span [ngClass]="isTiempoCritico(movil.estadoFechaTerminoPlanificado)">
                {{ movil.tiempoEnEstado }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="sideFiltros d-lg-none d-block" [ngClass]="{'colap' : !filtroColap}">

  <button class="btn btnClose" (click)="filtroColap = !filtroColap">
    <img src="assets/img/icoClose.svg" alt="">
  </button>
  <div class="title">Filtrar por:</div>

  <div class="select itemForm">
    <h6>Tipo de Bus</h6>
    <select class="form-select" [(ngModel)]="tipoBus" (ngModelChange)="onFiltroCambio()">
      <option disabled>Tipo de bus</option>
      <option value="Todos">Todos ({{cantidadTodos}})</option>
      <option value="A">A ({{cantidadTipoMovilA}})</option>
      <option value="B">B ({{cantidadTipoMovilB}})</option>
      <option value="C">C ({{cantidadTipoMovilC}})</option>
      <option value="BP">BP ({{cantidadTipoMovilBP}})</option>
    </select>
  </div>

  <div class="select itemForm">
    <h6>Unidad de Servicio</h6>
    <select class="form-select" [(ngModel)]="unidadSeleccionada" (ngModelChange)="onFiltroCambio()">
      <option disabled>Unidad de Servicio</option>
      <option value="Todos">Todos ({{cantidadTodos}})</option>
      <option value="conecta_17">Conecta_17 ({{cantidadUnidadConecta17}})</option>
      <option value="conecta_18">Conecta_18 ({{cantidadUnidadConecta18}})</option>
    </select>
  </div>

  <div class="select itemForm ">
    <h6>Tipo de Energía Bus</h6>
    <select class="form-select" [(ngModel)]="tipoSeleccionado" (ngModelChange)="onFiltroCambio()">
      <option disabled>Energía de Bus</option>
      <option value="Todos">Todos ({{cantidadTodos}})</option>
      <option value="ELECTRICO">Electricos ({{cantidadElectricos}})</option>
      <option value="DIESEL">Diesel ({{cantidadDiesel}})</option>
    </select>
  </div>

  <div class="select itemForm">
    <div class="slider-container">
      <label>Carga mín: {{ cargaElectricaMinima }}%</label>
      <input type="range" class="form-range" min="0" max="100" [(ngModel)]="cargaElectricaMinima"
        (change)="onMinChange(cargaElectricaMinima)" />
    </div>
  </div>
  <div class="select itemForm">
    <div class="slider-container">
      <label>Carga máx: {{ cargaElectricaMaxima }}%</label>
      <input type="range" class="form-range" min="0" max="100" [(ngModel)]="cargaElectricaMaxima"
        (change)="onMaxChange(cargaElectricaMaxima)" />
    </div>
  </div>

  <div class="buttons">
    <button class="btnBlack" (click)="filtroColap = !filtroColap">APLICAR FILTRO</button>
    <button class="btn btnClean" (click)="limpiarFiltros()">LIMPIAR FILTRO</button>
  </div>
</div>